import { render, staticRenderFns } from "./RuleTabTrigger.vue?vue&type=template&id=7e09171a&scoped=true&"
import script from "./RuleTabTrigger.vue?vue&type=script&lang=ts&"
export * from "./RuleTabTrigger.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e09171a",
  null
  
)

export default component.exports